import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

const routerOptions = [
  { path: '/', name: '', component: 'Landing' },
  { path: '/signin', name: 'signin', component: 'Signin' },
  { path: '/signup', name: 'signup', component: 'Signup' },
  { path: '/forgot', name: 'forgot', component: 'Forgot' },
  { path: '/home', name: 'home', component: 'Home', meta: { requiresAuth: true } },
  { path: '/storylist', name: 'storylist', component: 'StoryListView', meta: { requiresAuth: true } },
  { path: '/story/:title', name: 'storyview', component: 'StoryEditView', meta: { requiresAuth: true } },
  { path: '/timeline/:title', name: 'timeline', component: 'Timeline', meta: { requiresAuth: true } },
  { path: '/storyEditView/:title', name: 'storyEditView', component: 'StoryEditView', meta: { requiresAuth: true } },
  { path: '/admin', name: 'admin', component: 'Admin', meta: { requiresAuth: true } },
  { path: '/welcome', name: 'welcome', component: 'Welcome' },
  { path: '/contact', name: 'contact', component: 'Contact' },
  { path: '/faq', name: 'faq', component: 'FAQ' },
  { path: '/profile', name: 'profile', component: 'Profile', meta: { requiresAuth: true } },
  // { path: '/access', name: 'access', component: 'Access' },
  { path: '/gallery', name: 'gallery', component: 'Gallery' },
  { path: '/assets', name: 'assets', component: 'Assets', meta: { requiresAuth: true } },
  { path: '/userclass', name: 'userclass', component: 'UserClass', meta: { requiresAuth: true } },
  { path: '/visual', name: 'visual', component: 'Visual', meta: { requiresAuth: true } },
  // { path: '/writer', name: 'writer', component: 'Writer', meta: { requiresAuth: true } },
  { path: '*', name: 'other', component: 'NotFound' }
  // { path: '/temp', component: 'temp' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/views/${route.component}.vue`)
  }
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = firebase.auth().currentUser &&
    firebase.auth().currentUser.emailVerified

  if (requiresAuth && !isAuthenticated) {
    next('/signin')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js